import React from 'react';
import { Wordmark } from './Wordmark';
export function SiteHeader() {
  return <header className="bg-white" data-id="element-74" data-mp="19vrlpaqk58rm">
      <div className="mx-auto flex h-16 max-w-7xl items-center px-6" data-id="element-75" data-mp="19uglfkwbmj59">
        <Wordmark data-id="element-76" data-mp="1nmmw4rgpfxxb" />
      </div>
    </header>;
}